import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {EChartsOption} from "echarts";
import {AppState} from "../../../../shared/store/store";
import {Store} from "@ngrx/store";
import {MetricComponentObject, MetricComponentObjects} from '../../../../shared/classes/metric-component-object';
import {ChartStore} from '../../../../shared/store/quickDashboard/chart.store';
import {AdRPeriod} from '../../../../shared/interfaces/ad-reports';
import {selectMetricComponentObjects} from '../../../../shared/store/selectors';
import {selectDataSetMetricsGroupsInitialized} from '../../../../shared/store/dataSetMetricsGroups/dataSetMetricsGroups.selectors';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
  providers: [ChartStore]
})
export class ChartComponent implements OnInit, AfterViewInit, OnDestroy {
  public readonly metricsCtrl: FormControl<MetricComponentObjects> = this._chartStore.metricsCtrl;
  public readonly periodCtrl: FormControl<AdRPeriod> = this._chartStore.periodCtrl;
  public readonly formGrp: FormGroup<{ metrics: FormControl<MetricComponentObjects>, period: FormControl<AdRPeriod> }> = this._chartStore.formGrp;
  public readonly loading$: Observable<boolean> = this._chartStore.loading$;
  public readonly periods: Array<AdRPeriod> = this._chartStore.periods;

  public readonly validators: Array<ValidatorFn> = [Validators.required];

  public readonly metrics$: Observable<Array<MetricComponentObject>> = this._store.select(selectMetricComponentObjects);
  public readonly metricsLoading$: Observable<boolean> = this._store.select(selectDataSetMetricsGroupsInitialized).pipe(
    map((initialized: boolean): boolean => !initialized)
  );

  public readonly chartOption$: Observable<EChartsOption> = this._chartStore.chartOption$;

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _chartStore: ChartStore
  ) { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  public reload(): void {
    this._chartStore.load();
  }

  public formOnSubmit(): void {
    this._chartStore.load();
  }

  public onSave(): void {
    this._chartStore.save();
  }

}
